import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { initialize, isPristine } from 'redux-form';
import { CSSTransition, transit } from 'react-css-transition';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { updateCase, updateCaseClinicalTemp, setCaseStatus } from '../redux/actions';
import { getSelectedCase } from '../redux/reducers';
import {
  ModalInformation,
  AssignPathologistsTable,
} from '../components';
import { caseStatus, userRoles } from '../constants';
import { getNote4_specimensSubmitted } from '../constants/modal_content/PART_1_CLINICAL_INFORMATION_SPECIMEN_RECEIPT';
import PersonalInformationForm from '../forms/personalInformationForm/PersonalInformationForm';
import ClinicalInformationForm from '../forms/clinicalInformaionForm/ClinicalInformationForm';
import SpecimenTableForm from '../forms/specimenTableForm/SpecimenTableForm';

class CasePartOne extends PureComponent {
  componentWillUnmount() {
    /**
     * @todo
     * This role-check should just be temporary.
     * Added, due to late changes of this view for the validation study.
     * Since `<CasePartOneClinicalInformation />`
     */
    const { role } = this.props;
    if (role === userRoles.val_technician) {
      return;
    }

    const { selectedCase, genPristine, clinPristine } = this.props;
    // TODO: refactor handling of temporary saving
    const hasChanged = !(!selectedCase.generalHasChanged && genPristine && clinPristine);

    this.props.updateCaseClinicalTemp({
      caseGeneralInformation: this.props.form.caseGeneralInformation.values,
      caseClinicalInformation: this.props.form.caseClinicalInformation.values,
      hasChanged,
    });
  }

  handleSubmit = event => {
    event.preventDefault();
    const { form, role } = this.props;
    let workflowStatus = this.props.selectedCase.workflowStatus;
    if (workflowStatus !== caseStatus.workflowStatus.COMPLETE) {
      workflowStatus = caseStatus.workflowStatus.WAITING;
    }

    this.props.updateCase({
      _case: {
        id: this.props.selectedCase.id,
        status: {
          ...this.props.selectedCase.status,
          workflowStatus,
        },
        partOneGeneralInformation: form.caseGeneralInformation.values,
        partOneClinicalInformation: role !== userRoles.val_technician ? form.caseClinicalInformation.values : {},
      },
    });

    // updates redux-forms initial values, in order to make checkIfChangesHasBeenMade work properly
    // in Inbox.js when user selects case with unsaved changes. initialize() is a redux-form action creator.
    this.props.dispatch(
      initialize('caseGeneralInformation', form.caseGeneralInformation.values, true),
    );
    if (role !== userRoles.val_technician) {
      this.props.dispatch(
        initialize('caseClinicalInformation', form.caseClinicalInformation.values, true),
      );
    }
  };

  renderClinicalForm = userRole => (
    <form onSubmit={this.handleSubmit}>
      <PersonalInformationForm />
      {userRole !== userRoles.val_technician && <ClinicalInformationForm />}
      {(userRole === userRoles.admin || userRole === userRoles.surgeon) && (
        <div className="form-part-one-btn-wrapper">
          <button className="btn--form" type="submit">
            Save
          </button>
        </div>

      )}
      <i style={{ paddingTop: '20px' }}>The source of this form is the International Collaboration on Cancer Reporting. 2017. Prostate Core Needle Biopsy Histopathology Reporting Guide 1st edition. Sydney, Australia. ISBN: 978-1-925687-10-1.</i>
    </form>
  );

  renderAssignPathologistTable = (newCaseId, selectedCaseId, userRole) => {
    if (
      (newCaseId !== null && selectedCaseId === newCaseId)
      || userRole === userRoles.pathologist
      || userRole === userRoles.val_technician
    ) {
      return null;
    }

    return (
      <div className="grey-wrapper grey-wrapper-pathologists-assigned">
        <section className="form-part-one-specimen-submitted">
          <span>PATHOLOGISTS ASSIGNED</span>
        </section>
        <AssignPathologistsTable key={selectedCaseId} />
      </div>
    );
  };

  renderSpecimenTable = (newCaseId, selectedCaseId, userRole) => {
    if (
      (newCaseId !== null && selectedCaseId === newCaseId)
      || userRole === userRoles.pathologist
    ) {return null;
    }

    return (
      <>
        <div className="grey-wrapper">
          <p className="form-part-one-specimen-submitted">
            SPECIMENS SUBMITTED
            <ModalInformation>{getNote4_specimensSubmitted()}</ModalInformation>
          </p>
          {/* <CaseSpecimenUploadModal />
          <CasePartOneSpecimenTable /> */}
          <SpecimenTableForm key={selectedCaseId} />
        </div>


      </>
    );
  };

  setCaseStatusToAwaitingUpload = () => {
    const { setCaseStatus, selectedCase } = this.props;
    const { workFlowStatusDemo: { AWAITING_UPLOAD } } = caseStatus;
    setCaseStatus(AWAITING_UPLOAD, selectedCase.id);
  }

  renderSendToLabButton = () => {
    const { disableSendToLabButton } = this.props;

    return (
      <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingBottom: '20px' }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          disabled={disableSendToLabButton}
          onClick={this.setCaseStatusToAwaitingUpload}
        >
          Send To Lab
        </Button>
      </div>
    )

  }

  render() {
    const { selectedCase, role, shouldRenderPathologistTable, shouldRenderSendToLabButton } = this.props;
    return (
      <div className="main-content">
        <CSSTransition
          defaultStyle={{ opacity: transit(0, 100, 'ease-in-out') }}
          enterStyle={{ opacity: transit(0.5, 100, 'ease-in-out') }}
          activeStyle={{ opacity: 1.0 }}
          active={this.props.displayWrapper}
        >
          <div className="grey-wrapper" style={{ marginBottom: '30px' }}>
            <div className="partone-form-wrapper">
              {this.renderClinicalForm(role)}
            </div>
          </div>
          {/* Render SpecimenTable as long as selected
              case isn't a new case that hasn't been saved yet
            */}
          {this.renderSpecimenTable(this.props.newCaseId, selectedCase.id, role)}

          {/* Render AssignPathologistTable as long as selected
              case isn't a new case that hasn't been saved yet,
              or logged in user has role 'pathologist' */}
          {shouldRenderPathologistTable && this.renderAssignPathologistTable(this.props.newCaseId, selectedCase.id, role)}
          {shouldRenderSendToLabButton && this.renderSendToLabButton()}
        </CSSTransition>
      </div>
    );
  }
}

CSSTransition.childContextTypes = {
  // this can be empty
};

CasePartOne.propTypes = {
  selectedCase: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    specimens: PropTypes.array,
  }).isRequired,
};

const mapStateToProps = state => {
  const { _case, form, auth } = state;
  const { user } = auth;
  const genPristine = isPristine('caseGeneralInformation')(state);
  const clinPristine = isPristine('caseClinicalInformation')(state);

  const {
    cases, specimens, displayWrapper, newCaseId, displayNotification, assignedPathologists,
  } = _case;

  const selectedCase = getSelectedCase(state);

  const { workFlowStatusDemo: { CASE_CREATED, AWAITING_UPLOAD } } = caseStatus;
  const currentCaseStatus = selectedCase.status.workFlowStatusDemo;


  const shouldRenderPathologistTable = (user.role === userRoles.admin || user.role === userRoles.surgeon);

  const enableSendToLabButton = selectedCase._id !== undefined
    && specimens.length > 0
    && assignedPathologists.length > 0;

  const shouldRenderSendToLabButton = (user.role === userRoles.surgeon || user.role === userRoles.admin)
    && currentCaseStatus === CASE_CREATED;

  return {
    cases,
    selectedCase,
    form,
    specimens,
    displayWrapper,
    newCaseId,
    displayNotification,
    genPristine,
    clinPristine,
    currentCaseStatus,
    shouldRenderPathologistTable,
    disableSendToLabButton: !enableSendToLabButton,
    shouldRenderSendToLabButton,
  };
};

const mapDispatchToProps = dispatch => ({
  updateCase: data => {
    dispatch(updateCase(data));
  },
  updateCaseClinicalTemp: data => {
    dispatch(updateCaseClinicalTemp(data));
  },
  setCaseStatus: (status, caseId) => {
    dispatch(setCaseStatus(status, caseId));
  },
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CasePartOne);
